// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  placementId: __t.u64().primaryKey().name("placement_id"),
  worldId: __t.u64().name("world_id"),
  prefabKey: __t.string().name("prefab_key"),
  kind: __t.string(),
  posX: __t.f32().name("pos_x"),
  posY: __t.f32().name("pos_y"),
  posZ: __t.f32().name("pos_z"),
  rotX: __t.f32().name("rot_x"),
  rotY: __t.f32().name("rot_y"),
  rotZ: __t.f32().name("rot_z"),
  rotW: __t.f32().name("rot_w"),
  scaleX: __t.f32().name("scale_x"),
  scaleY: __t.f32().name("scale_y"),
  scaleZ: __t.f32().name("scale_z"),
  placedBy: __t.identity().name("placed_by"),
  placedAt: __t.timestamp().name("placed_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
